<template>
  <div v-if="ready">
    <div
      v-for="(item, index) in data"
      :key="index"
      class="form-row form-control-mobile mb-mobile-2"
      @click="clickAtSingleList(index)">
      <div
        :class="{'col-md-9': !disabled, 'col-md-8': disabled}"
        class="mb-2"
        style="height: 38px;">
        <div class="d-flex">
          <div style="flex: 1;">
            <template>
              <vue-bootstrap-autocomplete
                v-if="!disabled"
                v-model="item.queryProductName"
                :data="(() => {
                  return !item.sku_id && !item.is_saving_product
                    ? [
                      {
                        text: '',
                        sku_code: '',
                        value: '',
                      },
                      ...optionSkus
                    ]
                    : []
                })()"
                :serializer="(item) => item.text + ' ' + (item.sku_code || '')"
                :minMatchingChars="1"
                :maxMatches="10"
                :placeholder="createAble ? $t('placeholder.selectorcreate') : $t('placeholder.selectitem')"
                :loading="item.selectize.loading"
                :state="(() => {
                  if(item.selectize.trickValidation > 0) {
                    return !item.sku_id ? false : null
                  } else {
                    return null
                  }
                })()"
                :disabled="item.is_saving_product"
                @input="($event) => {
                  data[index].selectize.loading = true
                  lookupProducts(index, $event)
                }"
                @hit="handleSelectProduct(index, $event)"
                @blur="handleBlurProduct(index, $event)"
                @inputBlur="handleInputBlurProduct(index, $event)"
                @keydown="handleKeydownProduct(index, $event)"
                @keyup="handleKeyupProduct(index, $event)"
              >
                <template
                  v-if="item.queryProductName"
                  slot="create"
                  slot-scope="{ data, htmlText }">
                  <div
                    style="cursor: pointer;"
                    @mousedown="onAddedSku(item.queryProductName)"
                  >
                    <span class="text-success">
                      <i class="fas fa-plus"/>
                      {{ $t('message.addnewproduct') }}
                    </span>
                    <span style="color: #8f9295;">
                      {{ item.queryProductName }}
                    </span>
                  </div>
                </template>
                <template
                  slot="suggestion"
                  slot-scope="{ data, htmlText }">
                  <div class="d-flex align-items-center">
                    <img
                      :src="productImage(data.value)"
                      style="width: 40px; height: 40px; border-radius: 0.25rem;"
                    >
                    <div class="d-flex flex-column">
                      <span
                        class="ml-4"
                        v-html="data.text"/>
                      <span
                        class="ml-4"
                        style="font-size: 11px;"
                        v-html="data.sku_code"/>
                    </div>
                  </div>
                </template>
              </vue-bootstrap-autocomplete>
              <input
                v-else
                :disabled="disabled"
                :value="item.item"
                type="text"
                class="form-control">
            </template>
          </div>
        </div>
      </div>
      <div class="col-md-2 mb-2">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">{{ $t('message.quantity') }}</span>
          </div>
          <input
            :disabled="item.sku_id.length == 0 || disabled || isUseLot(item.sku_id) || isUseSerial(item.sku_id)"
            v-model="item.quantity"
            type="text"
            class="form-control text-right number-only text-select-all"
            placeholder=""
            @keypress="numberOnly"
            @keyup="item.quantity = setToValidNumber(item.quantity)"
            @blur="item.quantity = setToCustomDigitsNumber(item.quantity)">
        </div>
      </div>
      <div
        v-if="disabled"
        class="col-md-2 mb-2">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">{{ $t('apps.inventory.message.deliveredcount') }}</span>
          </div>
          <input
            :class="{'text-success': item.done >= item.quantity, 'text-danger': item.done < item.quantity}"
            :disabled="true"
            v-model="item.done"
            type="text"
            class="form-control text-right number-only text-select-all"
            placeholder="0">
        </div>
      </div>
      <div
        v-if="!disabled"
        class="col-md-1 mb-2 text-center">
        <button
          class="btn col-12"
          @click="del(index)">
          <i class="far fa-trash-alt"/>
        </button>
      </div>
      <template v-if="isUseLot(item.sku_id)">
        <BaseSelectLotNumber
          :index="index"
          :skuId="item.sku_id"
          :selected="item.lot.selected"
          :disabled="disabled"
          :label="`${$t('apps.inventory.label.lotnumber')}: ${$t('apps.inventory.label.pickfrom')}`"
          :selectedWhId="selectedWhIdFrom"
          :selectedBinId="pickedBinIdFrom"
          :style="disabled ? `margin-bottom: -8px !important;` : ``"
          @onSubmit="handleSubmitLotNumber"
        />
        <BaseGTPutAwayLot
          v-model="item.lot"
          :warehouses="warehouses"
          :selectedWhId="selectedWhIdTo"
          :disabled="true"
          :label="`${$t('apps.inventory.label.lotnumber')}: ${$t('apps.inventory.label.putawayto')}`"
        />
      </template>
      <template v-else-if="isUseSerial(item.sku_id)">
        <BaseSelectSerialNumber
          :index="index"
          :skuId="item.sku_id"
          :selected="item.serial.selected"
          :disabled="disabled"
          :label="`${$t('apps.inventory.label.serialnumber')}: ${$t('apps.inventory.label.pickfrom')}`"
          :selectedWhId="selectedWhIdFrom"
          :selectedBinId="pickedBinIdFrom"
          :style="disabled ? `margin-bottom: -8px !important;` : ``"
          @onSubmit="handleSubmitSerialNumber"
        />
        <BaseGTPutAwaySerial
          v-model="item.serial"
          :warehouses="warehouses"
          :selectedWhId="selectedWhIdTo"
          :disabled="true"
          :label="`${$t('apps.inventory.label.serialnumber')}: ${$t('apps.inventory.label.putawayto')}`"
        />
      </template>
    </div>
    <section
      v-if="!disabled"
      class="mb-3">
      <button
        class="btn"
        @click="add()">{{ $t('button.addproduct') }}</button>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import useBarcodeScanner from '../../use/barcodeScanner'
import { getIsBarcode } from '../../helpers'
import orderAutocompleteInventoryDocMixin from '../../mixins/orderAutocompleteInventoryDoc'

export default {
  mixins: [orderAutocompleteInventoryDocMixin],

  props: {
    data: {
      type: Array,
    },
    validation: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    createAble: {
      type: Boolean,
      default: true,
    },
    showProductImage: {
      type: Boolean,
      default: true,
    },
    selectedWhIdFrom: String,
    selectedWhIdTo: String,
    pickedBinIdFrom: String,
    pickedBinIdTo: String,
  },

  setup () {
    const {
      barcode,
    } = useBarcodeScanner({ delay: 100 })

    return {
      barcode,
    }
  },

  data () {
    return {
      ready: false,

      productsAvailable: [],

      optionSkus: [],
      updateOptionSkus: null,
      loadingSkus: false,
      trickValidationSkus: 0,

      focusAtIndex: 0,
      isFocusOnInput: false,

      isDisabledScanBarcode: false,
    }
  },
  computed: {
    ...mapGetters({
      products: 'getProducts',
      getProductInfoBySkuId: 'getProductInfoBySkuId',
      defaultImages: 'getDefaultImages',
      isAssignedInWarehouse: 'isAssignedInWarehouse',
      isUseLot: 'isUseLot',
      isUseSerial: 'isUseSerial',
      warehouses: 'getWarehouses',
    }),
  },
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    validation () {
      this.validateform()
    },
    data () {
      this.isFocusOnInput = false
    },
    selectedWhIdFrom () {
      this.setProductsAvailable()
    },
    selectedWhIdTo () {
      this.setProductsAvailable()
    },
    pickedBinIdTo() {
      for (const index in this.data) {
        if (this.data[index].use_lot) {
          this.data[index].lot.binId = this.pickedBinIdTo
        } else if (this.data[index].use_serial) {
          this.data[index].serial.binId = this.pickedBinIdTo
        }
      }
    },
  },
  async created () {
    // set ready
    this.ready = true
    // default
    if (!this.disabled && this.data.length == 0) {
      this.add()
      this.add()
    }

    // set to digits number
    for (let i in this.data) {
      this.data[i].quantity = this.setToCustomDigitsNumber(this.data[i].quantity)
      this.data[i].price = this.setToCustomDigitsNumber(this.data[i].price)
      this.data[i].done = this.setToCustomDigitsNumber(this.data[i].done)

      this.data[i].queryProductName = this.data[i].item
      this.data[i].image = ''
      this.data[i].is_saving_product = false
    }

    window.addEventListener('barcode', this.onBarcode)
  },
  destroyed: function () {
    window.removeEventListener('barcode', this.onBarcode)
  },
  methods: {
    inputClick (index) {
      let isLast = index == this.data.length - 1
      if (isLast) {
        this.add()
      }
    },
    add () {
      var that = this
      that.focusAtIndex = that.data.length
      that.data.push({
        sku_id: '',
        item: '',
        description: '',
        quantity: this.setToCustomDigitsNumber(0),
        price: this.setToCustomDigitsNumber(0),
        selectize: {
          loading: false,
          updateOption: null,
          trickValidation: 0,
        },
        use_lot: false,
        use_serial: false,
        lot: {
          selected: [],
          binId: null,
        },
        serial: {
          selected: [],
          binId: null,
        },
        queryProductName: '',
        image: '',
        is_saving_product: false,
      })
    },
    del (index) {
      this.data.splice(index, 1)

      let that = this
      if (that.data.length == 0) {
        setTimeout(() => {
          that.add()
        }, 100)
      }
    },
    getData () {
      var data = _.cloneDeep(this.data)

      var newData = []

      // remove key, data we don't need
      for (let i in data) {
        let order = data[i]
        if (order.sku_id) {
          newData.push({
            sku_id: order.sku_id,
            item: order.item,
            description: order.description,
            quantity: parseFloat(order.quantity) || 0,
            lot: order.lot,
            serial: order.serial,
            use_lot: this.isUseLot(order.sku_id),
            use_serial: this.isUseSerial(order.sku_id),
          })
        }
      }

      return newData
    },
    isValid () {
      /*
       *  validation
       */
      let data = this.getData()

      if (data.length == 0) {
        this.data[0].selectize.trickValidation++
      }

      return data.length != 0
    },
    validateform () {
      var data = null
      var isValid = false
      if (this.isValid()) {
        data = this.getData()
        isValid = true
      }
      this.$emit('submit', isValid, data)
    },
    onPickedSku (value) {
      let sku_id = value
      let sku = this.getSku(sku_id)
      if (sku) {
        let data = this.data.find((order, index) => index == this.focusAtIndex)
        this.focusAtIndex++
        if (data) {
          if (data.sku_id.length > 0 && this.isFocusOnInput) {
            data.item = sku.product_name
            data.description = sku.product_name
            if (sku.config.inventory.use_lot || sku.config.inventory.use_serial) {
              data.quantity = this.setToCustomDigitsNumber(0)
            } else {
              data.quantity = this.setToCustomDigitsNumber(1)
            }
            data.price = 0
            data.use_lot = sku.config.inventory.use_lot
            data.use_serial = sku.config.inventory.use_serial

            const isLot = this.isUseLot(sku_id)
            const isSerial = this.isUseSerial(sku_id)
            if (isLot) {
              data.lot.binId = this.pickedBinIdTo
            }
            else if (isSerial) {
              data.serial.binId = this.pickedBinIdTo
            }
          }
        }
      }
    },
    async onAddedSku (value) {
      if (isBarcode) {
        this.isDisabledScanBarcode = true
        setTimeout(() => {
          this.isDisabledScanBarcode = false
        }, 300)

        let data = this.data.find((order, index) => index == this.focusAtIndex)
        const sku = this.getSkuByBarcode(value)
        if (sku) {
          data.sku_id = sku.sku_id
          data.item = sku.product_name
          data.description = sku.product_name
          data.quantity = '1.00'
          data.price = 0
          data.selectize = {
            'loading': false,
            'updateOption': null,
            'trickValidation': 0,
          }
          data.done = 0
          data.use_lot = false
          data.use_serial = false
        } else {
          data.sku_id = ''
          data.item = ''
          data.description = ''
          data.quantity = '0.00'
          data.price = 0
          data.selectize = {
            'loading': false,
            'updateOption': null,
            'trickValidation': 0,
          }
          data.done = 0
          data.use_lot = false
          data.use_serial = false

          this.ready = false
          setTimeout(() => {
            this.ready = true
          }, 1)

          this.notify(this.$vs, {
            text: this.$t('message.notfoundbarcode', { code: value }),
            color: 'warning',
            icon: 'warning',
            time: 3000,
          })
        }
        return
      }

      let data = this.data.find((order, index) => index == this.focusAtIndex)
      let sku = this.getSku(value)

      if (sku == null) {
        data.selectize.loading = true
        data.is_saving_product = true
        this.optionSkus = []

        let res = await this.$store.dispatch('insertProduct', {
          product_name: value,
          type: 'product',
          assign_inventory: true,
          assign_pos: false,
        })

        if (res.success) {
          let product = res.data
          let sku_id = product.skus[0].sku_id

          // fetch new data
          await this.$store.dispatch('getWarehouses')

          // update data
          data.item = value
          data.sku_id = sku_id
          data.item = data.item || value
          data.description = value
          data.quantity = this.setToCustomDigitsNumber(1)
          data.price = 0
          data.selectize.updateOption = {
            text: value,
            value: sku_id,
            picked: true,
          }

          // hide loading selectize
          data.selectize.loading = false
          data.is_saving_product = false

          // finish loading
          this.showFinish(this.$Progress)
        }
      }
    },
    setOptionSkus () {
      this.optionSkus = []
      for (let i in this.productsAvailable) {
        let item = this.productsAvailable[i]
        this.optionSkus.push({
          text: item.product_name,
          sku_code: item.sku_code,
          value: item.sku_id,
        })
      }
    },
    getSku (sku_id) {
      for (let i in this.productsAvailable) {
        let item = this.productsAvailable[i]
        if (item.sku_id == sku_id) {
          return item
        }
      }
      return null
    },
    getSkuByBarcode (barcode) {
      for (let i in this.productsAvailable) {
        let item = this.productsAvailable[i]
        if (item.barcode == barcode) {
          return item
        }
      }
      return null
    },
    getOrderTotal (order) {
      return parseFloat(order.price) * parseFloat(order.quantity)
    },
    clickAtSingleList (index) {
      this.focusAtIndex = index
      this.isFocusOnInput = true
    },
    setProductsAvailable () {
      this.productsAvailable = []
      for (let i in this.products) {
        let product = this.products[i]
        for (let j in product.prices) {
          let price = product.prices[j]
          const pass = (
            this.isAssignedInWarehouse(price.sku_id, this.selectedWhIdFrom) &&
            this.isAssignedInWarehouse(price.sku_id, this.selectedWhIdTo)
          )
          if (pass) {
            this.productsAvailable.push({
              product_name: this.getProductFullName(product.product_name, price.attributes),
              sku_id: price.sku_id,
              price: price.price || 0,
              cost: price.cost || 0,
              barcode: price.barcode,
              unit: product.unit,
              config: price.config,
              sku_code: price.sku_code,
            })
          }
        }
      }
      for (let i in this.data) {
        const hasSku = this.data[i].sku_id
        const notExist = !this.productsAvailable.find((item) => item.sku_id === this.data[i].sku_id)
        if (hasSku && notExist) {
          this.productsAvailable.push({
            product_name: this.data[i].item,
            sku_id: this.data[i].sku_id,
            price: this.data[i].price || 0,
            cost: 0,
            unit: null,
            sku_code: this.data[i].sku_code,
          })
        }
      }
      this.setOptionSkus()
    },
    async onBarcode (event) {
      if (this.disabled || this.isDisabledScanBarcode) {
        return
      }

      this.isDisabledScanBarcode = true
      setTimeout(() => {
        this.isDisabledScanBarcode = false
      }, 600)

      const addAtIndex = this.data.findIndex((order, index) => !order.sku_id)
      const sku = await (async () => {
        let sku = this.getSkuByBarcode(event.detail.code)
        if (!sku) {
          const response = await this.$store.dispatch('getProducts', {
            page: 1,
            limit: 1,
            q: event.detail.code,
            no_category: true,
            no_modifier: true,
            no_discount: true,
            no_tax: true,
          })
          this.setProductsAvailable()
          sku = this.getSkuByBarcode(event.detail.code)
          this.showFinish(this.$Progress)
        }
        return sku
      })()
      const isSkuExistAtIndex = sku && this.data.findIndex((item) => item.sku_id == sku.sku_id)

      if (sku) {
        if (isSkuExistAtIndex >= 0) {
          const data = this.data[isSkuExistAtIndex]
          data.quantity = (Number(data.quantity) + 1).toFixed(2)
        } else if (addAtIndex === -1) {
          this.data.push({
            'sku_id': sku.sku_id,
            'item': sku.product_name,
            'description': sku.product_name,
            'quantity': '1.00',
            'price': 0,
            'selectize': {
              'loading': false,
              'updateOption': null,
              'trickValidation': 0,
            },
            'done': 0,
            'queryProductName': sku.product_name,
            'image': this.productImage(sku.sku_id),
            'is_saving_product': false,
          })
        } else {
          const data = this.data[addAtIndex]
          data.sku_id = sku.sku_id
          data.item = sku.product_name
          data.description = sku.product_name
          data.quantity = '1.00'
          data.price = 0
          data.selectize = {
            'loading': false,
            'updateOption': null,
            'trickValidation': 0,
          }
          data.done = 0
          data.queryProductName = sku.product_name
          data.image = this.productImage(sku.sku_id)
          data.is_saving_product = false
        }
      } else {
        this.notify(this.$vs, {
          text: this.$t('message.notfoundbarcode', { code: event.detail.code }),
          color: 'warning',
          icon: 'warning',
          time: 3000,
        })
      }

      this.blurInputAll()
    },
    productImage (skuId) {
      if (!skuId) return this.defaultImages.product
      const product = this.getProductInfoBySkuId(skuId)
      return (product && product.images.thumbnail) || this.defaultImages.product
    },
    handleSubmitLotNumber ({ index, lots = [] }) {
      this.data[index].lot.selected = lots
      this.data[index].quantity = lots.reduce((acc, cur) => {
        if (cur.unit !== '' && cur.unit !== null) {
          acc += Number(cur.unit)
        }
        return acc
      }, 0)
    },
    handleSubmitSerialNumber ({ index, serials = [] }) {
      this.data[index].serial.selected = serials
      this.data[index].quantity = serials.reduce((acc, cur) => {
        if (cur.unit !== '' && cur.unit !== null) {
          acc += Number(cur.unit)
        }
        return acc
      }, 0)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/custom/OrderGT.vue